import {Exclude, Expose, instanceToPlain, plainToInstance, Transform, Type} from "class-transformer";
import * as t from "io-ts";
import {validateJSON, validateJSONNow} from "../web/validation";
import {CargoSubtype, toCargoSubtype} from "./cargo-subtype";
import {getDatabaseCodeTransformer} from "./transfomers/transformers";
import {Default} from "../util/decorators";
import {TimeGroup, toTimeGroup} from "./time-group";
import {
    ContainerDNUStatisticsSnapshotEntryArrayValidator,
    ContainerDNUStatisticsSnapshotEntryEntity
} from "./container-dnu-statistics-snapshot-entry";

export const ContainerDNUStatisticsSnapshotValidator = t.intersection([
    t.type({
        objectId: t.string,
        cargoSubtype: t.string,
        objectType: t.string,
        timeGroup: t.string,
        regionId: t.string,
    }),
    t.partial({
        objectName: t.string,
        entries: ContainerDNUStatisticsSnapshotEntryArrayValidator,
    }),
]);

export const ContainerDNUStatisticsSnapshotArrayValidator = t.array(ContainerDNUStatisticsSnapshotValidator);

export type ContainerDNUStatisticsSnapshot = t.TypeOf<typeof ContainerDNUStatisticsSnapshotValidator>;
export type ContainerDNUStatisticsSnapshotArray = t.TypeOf<typeof ContainerDNUStatisticsSnapshotArrayValidator>;

@Exclude()
export class ContainerDNUStatisticsSnapshotEntity {
    @Expose()
    objectId!: string;

    @Expose()
    objectName?: string;

    @Expose()
    objectType!: string;

    @Expose()
    regionId!: string;

    @Expose()
    @Transform(getDatabaseCodeTransformer(toCargoSubtype))
    cargoSubtype!: CargoSubtype

    @Expose()
    @Transform(getDatabaseCodeTransformer(toTimeGroup))
    timeGroup!: TimeGroup

    @Expose()
    @Type(() => ContainerDNUStatisticsSnapshotEntryEntity)
    @Default([])
    entries: ContainerDNUStatisticsSnapshotEntryEntity[] = [];

    /**
     * Constructor for ContainerDNUStatisticsSnapshotEntity.
     * @hideconstructor
     */
    constructor() {
        // Empty constructor for 'class-transformer'
    }

    static from(containerContainerDNUStatisticsGroup: ContainerDNUStatisticsSnapshot): ContainerDNUStatisticsSnapshotEntity {
        return plainToInstance(
            ContainerDNUStatisticsSnapshotEntity,
            containerContainerDNUStatisticsGroup,
            {
                excludeExtraneousValues: true,
            }
        );
    }

    loadTypeValue(): Promise<ContainerDNUStatisticsSnapshot> {
        const object = instanceToPlain(this, {
            excludeExtraneousValues: true,
        });
        return validateJSON(ContainerDNUStatisticsSnapshotValidator, object);
    }

    asTypeValue(): ContainerDNUStatisticsSnapshot {
        const object = instanceToPlain(this, {
            excludeExtraneousValues: true,
        });
        return validateJSONNow(ContainerDNUStatisticsSnapshotValidator, object);
    }
}
